var scripts = document.getElementsByTagName("script");

for (var i = 0; i < scripts.length; i++){
  var src = scripts[i].getAttribute("src");
  if (/jaguar\.all/.test(src)) {
    __webpack_public_path__ = src.substr(0, src.lastIndexOf("/") + 1);
    window.PUBLIC_PATH = __webpack_public_path__;
    break;
  }
}

window.jQuery = window.$ = require('./js/jquery/jquery-2.0.3.js');

require('bootstrap/dist/js/bootstrap.js');

window.moment = require('./../../node_modules/moment/moment.js');
require('./../../node_modules/moment/locale/pt-br.js');

require('./js/jquery/jquery-migrate-1.2.1.min.js');
require('./js/jquery/jquery.select-filter.js');
require('./js/jquery/jquery.simplemodal-1.4.4.js');
require('./js/jquery/jquery.reject.js');
require('./js/jquery/jquery.maskMoney.js');
require('./js/jquery/jquery.maskedinput-1.3.js');
require('./js/jquery/jquery.idletimer.js');
require('./js/jquery/jquery.idletimeout.js');
require('./js/jquery/jqueryUI/js/jquery-ui-1.10.3.min.js');
require('./js/jquery/jqueryUI/js/jquery-ui-numeric.js');
require('./js/jquery/jquery_alert/jquery.alerts.js');
require('./js/jquery/jquery.tablesorter.min.js');
require('./js/jquery/jquery_file_upload/jquery.form.js');
require('./js/jquery/jquery_file_upload/jquery.uploadfile.js');

require('./js/jquery/jqueryUI/redmond/jquery-ui-1.10.3.css');
require('./js/jquery/jquery_alert/jquery.alerts.css');

var fsmenu = require('exports?FSMenu,addEvent,repositionMenus,activePageHighlight,getRef,getSty!./js/fsmenu/fsmenu');

Object.keys(fsmenu).map(function(i) {
  window[i] = fsmenu[i];
});



/*****************
 ** WEBPACK FOOTER
 ** ./jaguar/js.js
 ** module id = 1
 ** module chunks = 0 1
 **/